import React, {Component} from 'react'
import {dbase} from "../../firebase/index";
import {removeLeadingAndTrailingQuotations} from "../../utils/string";
import {LANDING, UNIT} from "../../constants/routes";
import {UnitListItem} from "./UnitListItem";
import {ACTION_SET_SELECTED_UNIT, ACTION_SET_UNITS, ACTION_SET_UPDATE_UNIT} from "../../reducers/constants";
import {connect} from "react-redux";
import {withRouter, Link} from "react-router-dom";
import {compose} from "recompose";
import {withScriptjs} from "react-google-maps";
import {getUnit, getUnitName} from "../unit/utils";
import {slide as LeftMenu} from 'react-burger-menu';
import {byPropKey} from "../utils";

/**
 * The dropdown list in the menu to be used to control the dashboard.
 */
class NavbarAuthUnitDropdown extends Component {
    constructor() {
        super();
        this.state = {
            isMobileLeftMenuOpen: false
        };
    }

    componentDidMount() {
        if (!this.props.selectedUnit) {
            this.setVehicleListListeners();
        }
    }

    /**
     * Closes the mobile menu on the left.
     */
    closeMobileMenu = () => {
        this.setState(byPropKey('isMobileLeftMenuOpen', false));
    };

    /**
     * Sets listeners that listens to the firebase vehicle list
     * in the global state to be displayed in the dropdown menu.
     */
    setVehicleListListeners = () => {
        // Get the vehicle list from firebase, map the whole object to {@code vehicleList}

        // 1. Attempt getting the units(keys, validity) belonging to an authUser
        dbase.doOnUnitsByUserValueChanged(this.props.authUser.uid,
            snapshot => {
                // 2. Reset existing units state, preventing a state persistence security leak.
                Object.keys(this.props.units).map(unitID => {
                    dbase.doOffUnitValueChanged(removeLeadingAndTrailingQuotations(unitID));
                    return null;
                });
                this.props.onSetUnits({});
                this.props.onSetSelectedUnit(null);

                // 3. Check validity of each entry
                snapshot &&
                snapshot.val() &&
                Object.keys(snapshot.val()).map(unitID => {

                    // 4. Attempt to get the main object of the unit from the units table
                    unitID &&
                    snapshot.val()[unitID] &&
                    dbase.doOnUnitValueChanged(removeLeadingAndTrailingQuotations(unitID),
                        snapshot => {
                            // The elevation service used to update elevation of the unit
                            const elevator = new window.google.maps.ElevationService();
                            // The unit's latitude and longitude in GoogleMaps LatLng format
                            const unitLatLng = new window.google.maps.LatLng(snapshot.val().latitude, snapshot.val().longitude);

                            // TODO: Move elevation logic into Java codebase
                            // 5. Attempt to load the elevation into the unit object.
                            elevator.getElevationForLocations({locations: [unitLatLng]}, (results, status) => {
                                if (status === "OK") {
                                    // Case for successful elevation data

                                    // 6. Append {@code units} with new data that comes in from firebase
                                    this.props.onUpdateUnit(getUnit(removeLeadingAndTrailingQuotations(unitID), {
                                        elevation: parseFloat(results[0].elevation.toFixed(2)),
                                        ...snapshot.val()
                                    }));
                                } else {
                                    // Case for unsuccessful elevation data
                                    // 6. Append {@code units} with new data that comes in from firebase
                                    this.props.onUpdateUnit(getUnit(removeLeadingAndTrailingQuotations(unitID), {
                                        elevation: null,
                                        ...snapshot.val()
                                    }));
                                }
                            });
                        });
                    return null;
                });
            });
    };

    /**
     * Gets the currently selected unit's name or return a dummy string if not available
     */
    getselectedUnitName = () => {
        if (this.props.selectedUnit) {
            return getUnitName(this.props.selectedUnit);
        } else {
            return 'Select a Vehicle';
        }
    };

    /**
     * To be called when the user clicks on any {@code UnitListItem}
     */
    onListItemClick = (unit) => (event) => {
        this.props.onSetSelectedUnit(unit);
        this.props.history.push(UNIT);
        this.closeMobileMenu();
    };

    render() {
        const selectedUnitName = this.getselectedUnitName();
        return (
            this.props.mobile
                ? (<LeftMenu isOpen={this.state.isMobileLeftMenuOpen} className={"left-menu"}>
                    {
                        Object.keys(this.props.units).length > 0
                            ? (Object.keys(this.props.units).map(unitKey =>
                                <UnitListItem
                                    key={unitKey}
                                    unit={getUnit(unitKey, this.props.units[unitKey])}
                                    onClick={this.onListItemClick}
                                    selectedUnit={this.props.selectedUnit}
                                />
                            ))
                            : <a className={"dropdown-item bm-menu-item"} href={LANDING}>You have no vehicles</a>
                    }
                </LeftMenu>)
                : (<li className="nav-item dropdown">
                    <Link
                        className="nav-link dropdown-toggle"
                        to={UNIT}
                        id="navbarDropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {selectedUnitName}
                    </Link>

                    <div className="dropdown-menu bg-navbar" aria-labelledby="navbarDropdownMenuLink">
                        {
                            Object.keys(this.props.units).length > 0
                                ? (Object.keys(this.props.units).map(unitKey =>
                                    <UnitListItem
                                        key={unitKey}
                                        unit={getUnit(unitKey, this.props.units[unitKey])}
                                        onClick={this.onListItemClick}
                                        selectedUnit={this.props.selectedUnit}
                                    />
                                ))
                                : <a className={"dropdown-item"} href={LANDING}>You have no vehicles</a>
                        }
                    </div>
                </li>)
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser,
    units: state.unitsState.units,
    selectedUnit: state.unitsState.selectedUnit
});

/**
 * Map Redux {@param dispatch} a.k.a. actions to component props
 */
const mapDispatchToProps = (dispatch) => ({
    onSetUnits: (units) => dispatch({type: ACTION_SET_UNITS, units}),
    onUpdateUnit: (unit) => dispatch({type: ACTION_SET_UPDATE_UNIT, unit}),
    onSetSelectedUnit: (selectedUnit) => dispatch({type: ACTION_SET_SELECTED_UNIT, selectedUnit})
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(withScriptjs(NavbarAuthUnitDropdown));



// WEBPACK FOOTER //
// ./src/components/navigationbar/NavbarAuthUnitDropdown.jsx